import { useScrollToTop } from '@/shared/hooks/useScrollToTop';

export const ScrollToTop = () => {
  useScrollToTop();
  return null;
};
